import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M21 4H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM8 18H4V6h4v12zm6 0h-4V6h4v12zm6 0h-4V6h4v12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 6h4v12h-4zm6 0h4v12h-4zM4 6h4v12H4z",
  opacity: ".3"
})), 'ViewWeekTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewWeekTwoTone.js
// module id = 7129
// module chunks = 2